import { store } from '@wajeez-web/stores/base';
import { handleDispatchResult } from '@wajeez-web/core/utils';
import { Server } from '@wajeez-web/core/api-base';

import { openOnboardingContentEntityAsync } from './slices';

export const openOnboardingContentEntity = async (
  data: Server.OnBoardingGiveOpenContentEntityQuery,
  onSuccess?: () => void | Promise<void>,
  onComplete?: () => void
) => {
  const res = await store.dispatch(openOnboardingContentEntityAsync(data));

  return handleDispatchResult(res, onSuccess, onComplete);
};
